import { render, staticRenderFns } from "./callExample.vue?vue&type=template&id=ffb6abfe&scoped=true"
import script from "./callExample.vue?vue&type=script&lang=js"
export * from "./callExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb6abfe",
  null
  
)

export default component.exports